import makeStyles from '@material-ui/core/styles/makeStyles';
import { fade } from '@material-ui/core';

export default makeStyles((theme) => ({
  wrapper: {
    minHeight: 90
  },
  formControl: {
    '& label': {
      [theme.breakpoints.down('xs')]: {
        fontSize: '.9rem'
      },
    },
    width: '100%'
  },
  root: {
    width: 400,
    border: '1px solid #e2e2e1',
    overflow: 'hidden',
    borderRadius: 5,
    backgroundColor: '#fcfcfb',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:hover': {
      backgroundColor: '#fff',
    },
    '&.Mui-focused': {
      backgroundColor: '#fff',
      boxShadow: `${fade(theme.palette.secondary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.secondary.main,
    },
    [theme.breakpoints.down('sm')]: {
      width: ({ isModalePasswordField }) => isModalePasswordField ? '60vw' : '100%'
    },
  },
  rootError: {
    '&$error': {
      color: theme.palette.secondary.main
    }
  },
  redRootError: {
    '&$error': {
      color: "#fff"
    }
  },
  error: {
  },
  icon: {
    marginRight: 5
  },
  helperText: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down("xs")]: {
      maxWidth: '50vw',
    }
  }
}));
